import { Skeleton, Stack } from '@mui/material';
import { useIsMobile } from '@/data/hooks/useIsMobile';

export const PersonalFormSkeleton = () => {
	const isMobile = useIsMobile();
	return (
		<Stack width={isMobile ? '100%' : '50%'} direction="column" spacing={0} paddingTop={'18px'}>
			<Skeleton variant="text" width={250} height={43} />
			<Skeleton variant="text" width={'100%'} height={100} />
			<Skeleton variant="text" width={'100%'} height={33} />
			<Stack width={'100%'} direction={isMobile ? 'column' : 'row'}>
				<Stack marginRight={isMobile ? '0px' : '10px'} width={'100%'} direction={'column'}>
					<Skeleton
						sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
						variant="rectangular"
						width={'100%'}
						height={50}
					/>
					<Skeleton
						sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
						variant="rectangular"
						width={'100%'}
						height={50}
					/>
					<Skeleton
						sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
						variant="rectangular"
						width={'100%'}
						height={50}
					/>
				</Stack>
				<Stack width={'100%'} direction={'column'}>
					<Skeleton
						sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
						variant="rectangular"
						width={'100%'}
						height={50}
					/>
					<Skeleton
						sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
						variant="rectangular"
						width={'100%'}
						height={50}
					/>
					<Skeleton
						sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
						variant="rectangular"
						width={'100%'}
						height={50}
					/>
				</Stack>
			</Stack>

			<Skeleton variant="text" width={'100%'} height={43} />

			<Skeleton variant="text" width={250} height={43} />
			<Skeleton
				sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
				variant="rectangular"
				width={'100%'}
				height={50}
			/>
			<Skeleton
				sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
				variant="rectangular"
				width={'100%'}
				height={50}
			/>
			<Skeleton
				sx={{ marginRight: '15px', borderRadius: '4px', marginBottom: '10px' }}
				variant="rectangular"
				width={'100%'}
				height={50}
			/>

			<Skeleton variant="text" width={'100%'} height={43} />
		</Stack>
	);
};
